module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/placement.a1117be5.svg";